import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, HtmlTrans, Typography } from 'web-library';

const LocalAddressHelper = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <Box className={className}>
      <Alert
        iconSize="M"
        title={t('profile->>AddressHelper.LocalAddressTitle')}
        message={
          <>
            <ul>
              <li>
                <Typography variant="body2">
                  <HtmlTrans
                    i18nKey="profile->>AddressHelper.LocalAddressPostalCodeMessage"
                    values={{
                      boldWord: 'NOT',
                    }}
                  />
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  <b>{t('profile->>AddressHelper.LocalAddressHouseBlockNo')}</b>
                  {t('profile->>AddressHelper.LocalAddressMessage')}
                  <b>{t('profile->>AddressHelper.LocalAddressNumber')}</b>
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  <b>{t('profile->>AddressHelper.LocalAddressStreetName')}</b>
                  {t('profile->>AddressHelper.LocalAddressMessage')}
                  <b>{t('profile->>AddressHelper.LocalAddressAlphabet')}</b>
                </Typography>
              </li>
              <li>
                <Typography variant="body2">
                  {t('profile->>AddressHelper.GCERegistrationAddressMessage')}
                </Typography>
              </li>
            </ul>
          </>
        }
        severity="info"
        variant="outlined"
        centreAlign={false}
      />
    </Box>
  );
};
export default LocalAddressHelper;
